import { css } from '@emotion/core';
export var profileButton = {
  name: "1db3q1",
  styles: "padding:0 8px;"
};
export var memberButton = {
  name: "19gygxs",
  styles: "white-space:nowrap;padding:2px 8px;"
};
export var spinner = {
  name: "16yb858",
  styles: "display:flex;height:32px;width:50px;align-items:center;padding-left:3px;"
};